<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<div *ngIf="!loading" class="relative rounded-lg">

  <!-- TABELA DESKTOP -->
  <div class="hidden md:block overflow-x-auto">
    <table class="w-full text-sm text-left text-gray-500 mb-8">
      <thead class="px-2 text-xs text-white bg-westetics-purple-300 mb-2">
        <tr class="text-left">
          <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
            Nome do Grupo
          </th>
          <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
            Qtd. Clínicas
          </th>
          <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
            Data de Criação
          </th>
          <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm text-right">
            Ações
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let group of groups" class="border-b hover:bg-gray-50">
          <td class="p-4 text-sm text-westetics-neutral-950">
            <a (click)="editGroup(group)" class="text-westetics-purple-800 hover:underline cursor-pointer font-medium">
              {{ group.name }}
            </a>
          </td>
          <td class="p-4 text-sm text-westetics-neutral-950">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-westetics-purple-100 text-westetics-purple-800">
              {{ group.clinic_count ?? 0 }}
            </span>
          </td>
          <td class="p-4 text-sm text-westetics-neutral-950">
            {{ formatDate(group.created_at) }}
          </td>
          <td class="p-4 text-sm text-right">
            <div class="flex items-center justify-end gap-2">
              <button (click)="editGroup(group)"
                      class="text-westetics-purple-800 hover:text-westetics-purple-600 transition-colors p-1"
                      title="Editar grupo">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                </svg>
              </button>
              <button (click)="showDeleteModal(group)"
                      class="text-red-500 hover:text-red-700 transition-colors p-1"
                      title="Excluir grupo">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- CARDS MOBILE -->
  <div class="md:hidden space-y-3 mb-6">
    <div *ngFor="let group of groups"
         (click)="editGroup(group)"
         class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow cursor-pointer">
      <div class="flex justify-between items-start mb-2">
        <div class="min-w-0 flex-1">
          <h3 class="text-sm font-semibold text-westetics-purple-800 truncate">{{ group.name }}</h3>
          <p class="text-xs text-westetics-neutral-600 mt-1">
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-westetics-purple-100 text-westetics-purple-800">
              {{ group.clinic_count ?? 0 }} clínica(s)
            </span>
          </p>
        </div>
        <div class="flex items-center gap-1 ml-2">
          <button (click)="showDeleteModal(group); $event.stopPropagation()"
                  class="text-red-500 hover:text-red-700 transition-colors p-1"
                  title="Excluir grupo">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="text-xs">
        <span class="text-westetics-neutral-500">Criado em:</span>
        <span class="ml-1 text-westetics-neutral-900">{{ formatDate(group.created_at) }}</span>
      </div>
    </div>
  </div>

  <!-- EMPTY STATE -->
  <div *ngIf="groups.length === 0" class="text-center py-16">
    <div class="flex flex-col items-center gap-4">
      <svg class="w-16 h-16 text-westetics-neutral-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
        </path>
      </svg>
      <p *ngIf="!searchTerm" class="text-westetics-neutral-600 text-sm">Nenhum grupo de clínicas cadastrado.</p>
      <p *ngIf="searchTerm" class="text-westetics-neutral-600 text-sm">Nenhum grupo encontrado para "{{ searchTerm }}".</p>
      <button *ngIf="!searchTerm" (click)="createGroup()"
              class="mt-2 bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white font-medium rounded-lg px-6 py-2 transition-colors cursor-pointer">
        Criar Novo Grupo
      </button>
    </div>
  </div>
</div>

<!-- DELETE CONFIRMATION MODAL -->
<div *ngIf="showConfirmDeletePopup"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-lg shadow-xl p-6 max-w-md mx-4 w-full">
    <h3 class="text-lg font-semibold text-westetics-neutral-950 mb-2">Excluir Grupo</h3>
    <p class="text-sm text-westetics-neutral-600 mb-1">
      Tem certeza que deseja excluir o grupo <strong>{{ groupToDelete?.name }}</strong>?
    </p>
    <p class="text-xs text-westetics-neutral-500 mb-6">
      As clínicas vinculadas a este grupo serão desvinculadas automaticamente (não serão excluídas).
    </p>
    <div class="flex justify-end gap-3">
      <button (click)="closeDeleteModal()"
              class="px-4 py-2 text-sm border border-westetics-gray-200 rounded-lg hover:bg-westetics-neutral-50 transition-colors">
        Cancelar
      </button>
      <button (click)="onDelete()"
              class="px-4 py-2 text-sm bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors">
        Excluir
      </button>
    </div>
  </div>
</div>
